/* eslint-disable max-len */
const log = require('log').create('spotlights', 'capture') // eslint-disable-line

const sheet_title = 'about.me - Email signups'
const message_placeholder = 'Please tell me how you found my page'

const before_setup_note = {
    field_type: 'note',
    predicate() {
        return this.setup && ! this.related_model.get('authenticated')
    },
    html: 'Leads will be collected in a Google Sheet. To activate this spotlight, please connect your Google account.',
}

const after_setup_note = {
    field_type: 'note',
    predicate() {
        return this.setup && this.related_model.get('authenticated')
    },
    calculated_values: {
        html() {
            const url = this.related_model.get('url')
            return `Your Google account is connected. Your leads will be collected in <a href="${url}" target="_blank" rel="noreferrer noopener">this Google Sheet</a>.`
        },
    },
}

const edit_note = {
    field_type: 'note',
    predicate() {
        return ! this.setup && this.related_model.get('authenticated')
    },
    calculated_values: {
        html() {
            const url = this.related_model.get('url')
            return `Your Google account is connected. Your leads are being collected in <a href="${url}" target="_blank" rel="noreferrer noopener">this Google Sheet</a>.`
        },
    },
}

const reauth_note = {
    field_type: 'note',
    predicate() {
        return ! this.setup && ! this.related_model.get('authenticated')
    },
    html: 'Your Google authentication has expired and your Spotlight button is not connected. To re-activate this spotlight, please connect your Google account.',
}

const connect_button = {
    field_type: 'buttonset',
    key: 'url',
    predicate() {
        return ! this.related_model.get('authenticated')
    },
    buttons: [
        {
            type: 'button',
            className: 'connect-google-sheets button fullwidth dark primary xlarge',
            label: 'Connect Google Sheets',
            loading_label: 'Connecting…',
        },
    ],
}

const save_button = {
    field_type: 'buttonset',
    predicate() {
        return this.related_model.get('authenticated') && this.related_model.isValid()
    },
    buttons: [
        {
            type: 'submit',
            className: 'button fullwidth dark primary xlarge',
            label: 'Save',
            loading_label: 'Saving…',
        },
    ],
}

const capture_list = [
    {
        id: 'get_notified',
        label: 'Get notified',
        glyph: 'megaphone',
        tweet_text(user) {
            return 'Get notified from my @aboutdotme page! 📰📧'
        },
        sheet_title,
        message_placeholder,
        fields: [
            before_setup_note,
            after_setup_note,
            reauth_note,
            edit_note,
            connect_button,
            save_button,
        ],
    },
    {
        id: 'join_email',
        label: 'Join my email list',
        glyph: 'email',
        default: true,
        tweet_text(user) {
            return 'Join my email list from my @aboutdotme page! 📰📧'
        },
        fields: [
            before_setup_note,
            after_setup_note,
            reauth_note,
            edit_note,
            connect_button,
            save_button,
        ],
    },
    {
        id: 'sign_newsletter_pro',
        label: 'Sign up for my newsletter',
        glyph: 'doc',
        tweet_text(user) {
            return 'Sign up for my newsletter from my @aboutdotme page! 📰📧'
        },
        sheet_title,
        message_placeholder,
        fields: [
            before_setup_note,
            after_setup_note,
            reauth_note,
            edit_note,
            connect_button,
            save_button,
        ],
    },
    {
        id: 'subscribe_newsletter',
        label: 'Subscribe to my newsletter',
        glyph: 'doc',
        tweet_text(user) {
            return 'Subscribe to my newsletter from my @aboutdotme page! 📰📧'
        },
        sheet_title,
        message_placeholder,
        fields: [
            before_setup_note,
            after_setup_note,
            reauth_note,
            edit_note,
            connect_button,
            save_button,
        ],
    },
]

// assign capture mechanism
// all spotlights in this list are premium
capture_list.forEach(spotlight => {
    spotlight.is_premium = true
    spotlight.mechanism = 'capture'
    spotlight.group = 'capture'
})

module.exports = capture_list
